import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** Footer 전용 색 — 시안값 (어두운 회색 배경 / 흐린 본문) */
const FOOTER_BG = '#454545'
const FOOTER_TEXT = '#D1D1D1'

export const FooterContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 40px 24px;
  background-color: ${FOOTER_BG};
`

export const FooterHeading = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.18px;
  color: ${COLORS.textInverse};
`

export const NotesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding-left: 19.5px;
`

export const NoteItem = styled.li`
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: ${FOOTER_TEXT};
  list-style: disc;
`
